import PropTypes from 'prop-types';
import { getPagePath, trans } from '@spotahome/soyuz/client';

import SupportCenter from '../SupportCenter';

import FooterBlock from './components/FooterBlock';
import FooterBlockTitle from './components/FooterBlockTitle';
import FooterLink from './components/FooterLink';

import FooterBlockList from './components/FooterBlockList';

const HelpFooter = ({ linkTheme }) => (
  <div>
    <FooterBlock>
      <FooterBlockTitle text={trans('footer.label.support')} />

      <SupportCenter backgroundColor="white" photo="blueShort" />
      <FooterBlockList>
        <FooterLink href={getPagePath('contact-us')} linkTheme={linkTheme}>
          {trans('footer.item.contact_support')}
        </FooterLink>
      </FooterBlockList>
    </FooterBlock>
  </div>
);

HelpFooter.propTypes = {
  linkTheme: PropTypes.string.isRequired
};

export default HelpFooter;
